import { createContext } from 'react';
export const AuthContextDefaults = {
    showAccessAlert: false,
    showPermissionAccessNotification: false,
    isAppLoading: false,
    isTokenPermissionsEmpty: true,
    authenticate: () => { },
};
export const AuthContext = createContext(Object.assign({}, AuthContextDefaults));
